import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export const TimeSlotWrapper = ({ children }: Props) => (
  <div className="flex flex-1" style={{ minHeight: "80px" }}>
    {children}
  </div>
);
